import React from "react";
import { AddTrusteeMasterContainer } from "../../../containers";

const AddTrusteeMaster = (props) => {
  return <AddTrusteeMasterContainer {...props} />;
};

export default AddTrusteeMaster;
